var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{attrs:{"data-testid":"portfolio-loader","aria-hidden":"true"}},[_c('SkeletonLoader',{staticClass:"text-group",attrs:{"show-animation":""}},[_c('div',{staticClass:"card-loader"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }